import { render, staticRenderFns } from "./guanggt_config.vue?vue&type=template&id=506d8d98&scoped=true&"
import script from "./guanggt_config.vue?vue&type=script&lang=js&"
export * from "./guanggt_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506d8d98",
  null
  
)

export default component.exports